export const DOCUMENTS_ON_DELETE_REQUESTED = 'DOCUMENTS_ON_DELETE_REQUESTED';
export const DOCUMENTS_ON_DELETE_SUCCEEDED = 'DOCUMENTS_ON_DELETE_SUCCEEDED';
export const DOCUMENTS_ON_DELETE_FAILED = 'DOCUMENTS_ON_DELETE_FAILED';

export const DOCUMENTS_ON_GET_ALL_REQUESTED = 'DOCUMENTS_ON_GET_ALL_REQUESTED';
export const DOCUMENTS_ON_GET_ALL_SUCCEEDED = 'DOCUMENTS_ON_GET_ALL_SUCCEEDED';
export const DOCUMENTS_ON_GET_ALL_FAILED = 'DOCUMENTS_ON_GET_ALL_FAILED';

export const DOCUMENTS_ON_GET_FORM_REQUESTED = 'DOCUMENTS_ON_GET_FORM_REQUESTED';
export const DOCUMENTS_ON_GET_FORM_SUCCEEDED = 'DOCUMENTS_ON_GET_FORM_SUCCEEDED';
export const DOCUMENTS_ON_GET_FORM_FAILED = 'DOCUMENTS_ON_GET_FORM_FAILED';

export const DOCUMENTS_ON_GET_ONE_REQUESTED = 'DOCUMENTS_ON_GET_ONE_REQUESTED';
export const DOCUMENTS_ON_GET_ONE_SUCCEEDED = 'DOCUMENTS_ON_GET_ONE_SUCCEEDED';
export const DOCUMENTS_ON_GET_ONE_FAILED = 'DOCUMENTS_ON_GET_ONE_FAILED';

export const DOCUMENTS_ON_SAVE_REQUESTED = 'DOCUMENTS_ON_SAVE_REQUESTED';
export const DOCUMENTS_ON_SAVE_SUCCEEDED = 'DOCUMENTS_ON_SAVE_SUCCEEDED';
export const DOCUMENTS_ON_SAVE_FAILED = 'DOCUMENTS_ON_SAVE_FAILED';
